<fe-header></fe-header>
<fe-progress-bar
    *ngIf="!breakpoint.isMobile()"
    [status]="'location'"
    class="d-none d-md-block"
    #progressBarDesktop
    [disabled]="true"
    [defaultLocation]="reservation.current.cityInternational?.name"
></fe-progress-bar>
<section class="container-fluid p-lg-0 main international_page">
    <div class="m-lg-0 p-lg-0">
        <div class="d-flex flex-column flex-lg-row">
            <div class="location-store-finder d-flex flex-column">
                <h2 class="title_block">
                    {{ 'fe_international_h3_title_select-office' | translate }}
                </h2>
                <span class="locatons-counts" *ngIf="locations.length > 0"
                    >{{ locations.length }} locations
                </span>
                <div class="d-flex flex-column location_list">
                    <ng-container *ngIf="locations.length > 0; else noBranches">
                        <fe-card-location
                            *ngFor="let location of locations; index as i"
                            [location]="location"
                            [index]="i + 1"
                        >
                        </fe-card-location>
                    </ng-container>

                    <ng-template #noBranches>
                        <div class="locations-noresults">
                            <h3>
                                {{
                                    'fe_validation_international_h3_noresult'
                                        | translate
                                }}
                            </h3>
                            <p>
                                {{
                                    'fe_validation_international_p_noresult'
                                        | translate
                                }}
                            </p>
                        </div>
                        <div class="locations-noresults-txt">
                            <p>
                                {{
                                    'fe_validation_international_p_noresultdetails'
                                        | translate
                                }}
                            </p>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="location_store_finder__map">
                <google-map
                    [center]="center"
                    [zoom]="zoom"
                    height="100%"
                    width="100%"
                >
                    <map-marker
                        #markerElem
                        *ngFor="let marker of markers"
                        [position]="marker.position"
                        id="marker.id"
                        [title]="marker.title"
                        [label]="marker.label"
                        [options]="marker.options"
                        (mapClick)="
                            selectMarckLocation(
                                marker.id,
                                marker.type,
                                marker.location
                            )
                        "
                        (mapMouseover)="onMouseOver(marker.id)"
                        (mapMouseout)="onMouseOut(marker.id)"
                    ></map-marker>
                </google-map>
            </div>
        </div>
    </div>
</section>
